export const extractAccountNumber = (str) => {
  const match = str.match(/Account No\s*[-]?\s*(\d+)/);
  return match ? match[1] : null;
};
